import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-center pt-3 pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-12 md:col-6 lg:col-6 p-2" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "product-code" }, "Kód", -1)
const _hoisted_7 = { class: "flex justify-content-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus placeholder-icon" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "col-12 md:col-6 lg:col-6 p-2" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "product-name" }, "Názov", -1)
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "product-length" }, "Dĺžka", -1)
const _hoisted_16 = { class: "field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "product-category" }, "Kategória", -1)
const _hoisted_18 = {
  key: 0,
  class: ""
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "product-producer" }, "Výrobca", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_24 = { class: "mt-2 flex flex-wrap justify-content-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PrimevueCard, { class: "sm:w-12 md:w-10 lg:w-10 xl:w-6" }, {
      title: _withCtx(() => [
        _createTextVNode("PRODUKT")
      ]),
      subtitle: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitHandler && $options.submitHandler(...args)), ["prevent"])),
          name: "productForm"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_InputText, {
                  class: _normalizeClass(["w-full", `${$setup.v$.product.code.$error ? 'bg-red-200' : ''}`]),
                  invalid: $setup.v$.product.code.$error,
                  modelValue: this.product.code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.product.code) = $event)),
                  type: "text",
                  name: "product-code",
                  id: "product-code"
                }, null, 8, ["class", "invalid", "modelValue"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.product.code.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("input", {
                  type: "file",
                  ref: "fileInput",
                  accept: "image/*",
                  style: {"display":"none"},
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.onFileChange && $options.onFileChange(...args)))
                }, null, 544),
                ($data.previewUrl)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "image-container",
                      onMouseover: _cache[4] || (_cache[4] = ($event: any) => ($data.showIcons = true)),
                      onMouseleave: _cache[5] || (_cache[5] = ($event: any) => ($data.showIcons = false))
                    }, [
                      _createElementVNode("img", {
                        src: $data.previewUrl,
                        alt: "Preview Image",
                        class: "uploaded-image"
                      }, null, 8, _hoisted_8),
                      ($data.showIcons)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "pi pi-pencil edit-icon",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.triggerFileInput && $options.triggerFileInput(...args)))
                          }))
                        : _createCommentVNode("", true),
                      ($data.showIcons)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            class: "pi pi-times delete-icon",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.removeImage && $options.removeImage(...args)))
                          }))
                        : _createCommentVNode("", true)
                    ], 32))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "image-container placeholder",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.triggerFileInput && $options.triggerFileInput(...args)))
                    }, _hoisted_10))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_InputText, {
                  class: _normalizeClass(["w-full", `${$setup.v$.product.name.$error ? 'bg-red-200' : ''}`]),
                  invalid: $setup.v$.product.name.$error,
                  modelValue: this.product.name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.product.name) = $event)),
                  type: "text",
                  name: "product-name",
                  id: "product-name"
                }, null, 8, ["class", "invalid", "modelValue"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.product.name.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_InputNumber, {
                  class: "w-full",
                  inputId: "product-length",
                  useGrouping: false,
                  modelValue: this.product.length,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.product.length) = $event)),
                  name: "product-length",
                  id: "product-length"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_PrimevueSelect, {
                  id: "product-category",
                  modelValue: this.selectedCategory,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.selectedCategory) = $event)),
                  options: this.categories,
                  optionLabel: "name",
                  placeholder: "Vyber kategóriu",
                  class: _normalizeClass(["w-full", `${$setup.v$.selectedCategory.$error ? 'bg-red-200' : ''}`]),
                  invalid: $setup.v$.selectedCategory.$error
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value.id != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "class", "invalid"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedCategory.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_InputText, {
                  class: "w-full",
                  modelValue: this.product.producer,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((this.product.producer) = $event)),
                  type: "text",
                  name: "product-producer",
                  id: "product-producer"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_PrimevueButton, {
              type: "submit",
              label: "Uložiť",
              text: "",
              raised: "",
              class: "uppercase"
            }),
            _createVNode(_component_router_link, { to: "/mod-stock/products" }, {
              default: _withCtx(() => [
                _createVNode(_component_PrimevueButton, {
                  label: "Zrušiť",
                  severity: "danger",
                  text: "",
                  raised: "",
                  class: "uppercase"
                })
              ]),
              _: 1
            })
          ])
        ], 32)
      ]),
      _: 1
    })
  ]))
}